import { PagedResult } from '@models/pagedResult';
import { ZodType } from 'zod';

export default async function fetchPages<T>(
  model: ZodType<T, any, any>,
  fetch: (skip: number, limit: number) => Promise<unknown>,
  { pageSize = 1000, max = Infinity }: { pageSize?: number; max?: number } = {},
) {
  let skip = 0;
  const limit = pageSize;
  const items: T[] = [];
  let page;

  do {
    const res = await fetch(skip, Math.min(limit, max - items.length));
    page = PagedResult(model).parse(res);
    items.push(...page.items);
    skip += limit;
  } while (page.hasMore && items.length < max);

  return items.slice(0, max);
}
